import { ColumnsType } from "antd/es/table";
import React from "react";
import { optionsReflex } from "types/config/dilated-net-retinoscopy";
const width = "20%";

const dryNetRetinoscopyColumnsTb1: ColumnsType = [
  {
    title: "-",
    dataIndex: "none",
    align:'center',
    width: "10%",
  },
  {
    title: "Cầu",
    dataIndex: "sph",
    align:'center',

    width: width,
  },
  {
    title: "Trụ",
    dataIndex: "cyl",
    align:'center',

    width: width,
  },
  {
    title: "Trục",
    dataIndex: "axis",
    align:'center',

    width: width,
  },
  {
    title: "Ánh đồng tử",
    dataIndex: "reflexType",
    align:'center',

    width: "30%",

    render: (v) => {
      const res = optionsReflex.find((e) => {
        if (e.value === v) {
          return e.label;
        }
      });
      return <div>{res?.label ?? ""}</div>;
    },
  },
];

export { dryNetRetinoscopyColumnsTb1 };
